<template>
    <div class="mg-grid__item">
        <article class="mg-card-fixed md:max-w-sm overflow-hidden shadow-lg border-t-8 mg-border-accent-lighter p-8 pb-0 hentry bg-white rounded-lg">
            <a v-if="post.mg_main_image" :href="post.mg_permalink">
                <img class="mb-4 block" :src="post.mg_main_image.sizes.large" :alt="post.mg_main_image.alt ? post.mg_main_image.alt : post.mg_main_image.title">
            </a>
            <div class="mb-4">
                <h3 class="text-lg tracking-medium leading-tight mb-6">
                    <a :href="post.mg_permalink" class="plain-link">{{title}}</a>
                </h3>
                <div class="entry-meta">
                    <ul class="list-reset flex mb-4 heading-font text-sm font-medium">
                        <li v-if="news_type && (news_type !== 'Uncategorized')" class="font-medium">
                            <span v-html="news_type"></span>
                        </li>
                        <li>{{ display_date }}</li>
                    </ul>
                </div>
                <p class="text-grey-darker text-base">
                    {{summary}}
                    <a :href="post.mg_permalink" class="uppercase text-sm">Read more &raquo;</a>
                </p>
            </div>
        </article>
    </div>
</template>

<script>
import { format } from 'date-fns'
export default {
  name: 'card',
  props: ['post'],
  data() {
    return {
      summary: '',
      news_type: '',
      display_date: ''
    }
  },
  computed: {
    title() {
      return this.post.post_title || this.post.title.rendered
    }
  },
  methods: {
    setNewsType() {
      const postType = this.post.post_type

      if (postType !== 'post') {
        this.news_type = this.post.mg_type_name
      } else if (postType == 'post' && this.post.mg_category) {
        this.news_type = this.post.mg_category[0]['name']
      }
    },
    makeSummary() {
      if (this.post.post_excerpt) {
        this.summary = this.post.post_excerpt
      } else {
        const $htmlHolder = $('<div />')

        const contentPreview =
          this.post.post_content
            .split(' ')
            .splice(0, 24)
            .join(' ') + '...'

        $htmlHolder.html(contentPreview)

        this.summary = $htmlHolder.text()
      }
    },
    addDisplayDate() {
      this.display_date = format(this.post.post_date, 'MMM D, YYYY')
    },
    updateMeta() {
      this.setNewsType()
      this.addDisplayDate()
      this.makeSummary()
    }
  },
  updated() {
    this.updateMeta()
  },
  created() {
    this.updateMeta()
  }
}
</script>



// WEBPACK FOOTER //
// src/js/vue-components/card.vue